/**
 * RouteTransitionOverlay – kratak pun ekran loader POSLE promene rute (ne na klik pre navigacije).
 * Rani klik + startTransition je ostavljao overlay na homepage dok se ruta nije promenila.
 */
import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingOverlay from './LoadingOverlay';

const ROUTE_OVERLAY_MIN_MS = 120;

/** Nakon OIDC callback-a SigninRedirectPage već pun ekran koristi LoadingOverlay — ne duplirati. */
const PATH_SKIP_ROUTE_OVERLAY_FROM = '/signin-oidc';

export default function RouteTransitionOverlay() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  const isInitialRef = useRef(true);
  const prevPathnameRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const raf1Ref = useRef(0);
  const raf2Ref = useRef(0);

  useLayoutEffect(() => {
    if (isInitialRef.current) {
      isInitialRef.current = false;
      prevPathnameRef.current = location.pathname;
      return;
    }

    if (hideTimeoutRef.current != null) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    if (raf1Ref.current) {
      cancelAnimationFrame(raf1Ref.current);
      raf1Ref.current = 0;
    }
    if (raf2Ref.current) {
      cancelAnimationFrame(raf2Ref.current);
      raf2Ref.current = 0;
    }

    const fromPath = prevPathnameRef.current;
    prevPathnameRef.current = location.pathname;

    if (fromPath === PATH_SKIP_ROUTE_OVERLAY_FROM) {
      setVisible(false);
      return;
    }

    const startedAt = Date.now();
    setVisible(true);

    raf1Ref.current = requestAnimationFrame(() => {
      raf1Ref.current = 0;
      raf2Ref.current = requestAnimationFrame(() => {
        raf2Ref.current = 0;
        const elapsed = Date.now() - startedAt;
        const remaining = Math.max(0, ROUTE_OVERLAY_MIN_MS - elapsed);
        hideTimeoutRef.current = window.setTimeout(() => {
          setVisible(false);
          hideTimeoutRef.current = null;
        }, remaining);
      });
    });

    return () => {
      if (raf1Ref.current) {
        cancelAnimationFrame(raf1Ref.current);
        raf1Ref.current = 0;
      }
      if (raf2Ref.current) {
        cancelAnimationFrame(raf2Ref.current);
        raf2Ref.current = 0;
      }
      if (hideTimeoutRef.current != null) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
  // Samo pathname — promena ?tab= na /profil nije nova ruta i ne sme duplirati pun ekran loader.
  }, [location.pathname, location.key]);

  return (
    <LoadingOverlay
      isLoading={visible}
      className="loading-overlay--route-transition"
      title="Учитавање..."
      message="Молимо сачекајте, учитава се страница."
    />
  );
}
